import { Avatar, Dropdown } from 'antd';
import s from './style.module.scss';
import defaultAvatarImg from '@/assets/images/web/default_avatar.png';
import { Display } from '@/components/Display/Display';
import { inject, observer } from 'mobx-react';
const UserInfo = (props) => {
    let { chatStore, grtAi } = props.store;
    const { goLogin, handleOutLogin } = chatStore;
    const { userInfo, isLogin, studentName, loginAndOutConfig } = grtAi;
    const { logout_config } = loginAndOutConfig;
    return (
        <>
            <div className={s['user-info-wrap']}>
                <div className={s['user-info']}>
                    <Display show={isLogin}>
                        <Dropdown
                            disabled={logout_config?.can_logout !== 1}
                            placement="topRight"
                            menu={{
                                items: [
                                    {
                                        key: '3',
                                        label: <span onClick={handleOutLogin}>退出登录</span>
                                    }
                                ]
                            }}
                            arrow
                        >
                            <div className={s['user-info-item']}>
                                <Avatar className={s['avatar']} src={userInfo?.avatar || defaultAvatarImg}></Avatar>
                                <span className={s['user-name']}>{studentName}</span>
                            </div>
                        </Dropdown>
                    </Display>
                    <Display show={!isLogin}>
                        <span onClick={goLogin} className={s['user-name']}>
                            请登录
                        </span>
                    </Display>
                </div>
            </div>
        </>
    );
};

export default inject('store')(observer(UserInfo));
